import React, { Component } from "react";
import Cookies from "js-cookie";
import { changeLang } from "../../actions/langAction";
import { connect } from "react-redux";
import Api from "../ServiceApi";
import moment from "moment";

function setCookies(item) {
  localStorage.setItem("informDetail", JSON.stringify(item));
  setTimeout(
    function () {
      window.location.assign("/MaxiOperation/inform_problem_detail");
    },
    1000
  );
}
class CardInform extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.myRef = React.createRef();
    this.state = { scrollTop: 0, data_translate: [], factupdate: false };
  }

  onScroll = () => {
    const scrollY = window.scrollY; //Don't get confused by what's scrolling - It's not the window
    const scrollTop = this.myRef.current.scrollTop;
    console.log(
      `onScroll, window.scrollY: ${scrollY} myRef.scrollTop: ${scrollTop}`
    );
    this.setState({
      scrollTop: scrollTop,
    });
  };

  async componentDidMount() {
    this.setState({
      data_translate: this.props.data_translate , 
      factupdate: true,
    });
  }

  render() {
    const { list, sel_id } = this.props;
    const bgcolor = list.job_id === sel_id ? "yellow" : "white";
    return (
      <div
        className="card-list-job mb-2"
        // style={{ background: bgcolor }}
        style={{ background: bgcolor, cursor: "pointer",  width: "586px" }}
        onScroll={this.onScroll}
        onClick={() =>
          setCookies(list)
        }
      >
        <div className="row mb-2">
          <div className="col-5">
            <div className="d-flex">
              <div>
                <img src={Api.absoluteUrl("/icon/marker_job.svg")} alt="" />
              </div>
              <div className="ml-2">
                <h4
                  className="mb-0"
                  // , whiteSpace: "nowrap"
                  style={{ lineHeight: "20px" }}
                >
                  <button
                    onClick={() =>
                      Cookies.set("job_id", list.job_id) +
                      Cookies.set("job_progress_id", list.job_progress_id) +
                      Cookies.set("project_id", list.project_id) +
                      Cookies.set("job_type_id", list.job_type_id)
                    }
                    // href="#"
                    className="font16 font-thai-b c-blue"
                    style={{whiteSpace : "nowrap"}}
                  >
                   {"ASSET ID"} {list.asset_code}
                  </button>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: "20px" }}>
          <div className="col" style={{ borderLeft: "2px solid #E8ECEF" }}>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "asset_code"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16">{list.asset_code}</div>
            </div>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "location_name"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16">{list.location_name}</div>
            </div>
          </div>
          <div className="col" style={{ borderLeft: "2px solid #E8ECEF" }}>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")]["inform_date"]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16">
                {moment(list.inform_date).format("DD/MM/YYYY HH:mm")}
              </div>
            </div>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "inform_detail"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16" >
                {list.inform_detail}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(CardInform);
